import TagManager from "react-gtm-module";

function UploadImageDoneButton({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "upload_images_done_button",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default UploadImageDoneButton;
